import { Inject, Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { environment } from '@env/environment';

import { SessionStorageService } from '@shared/services/storage';

@Injectable()
export class ContentLanguageInterceptor implements HttpInterceptor {
  constructor(
    private storageService: SessionStorageService,
    @Inject(DOCUMENT) private document: Document) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {

    const pathParts = this.document.location.pathname
      .split('/')
      .filter((part) => part.length);
    const lang = pathParts.length ? pathParts[0] : undefined;

    if (environment.availableLocales.includes(lang)) {
      this.storageService.setItem('language', lang);
    }
    const language = this.storageService.getItem('language') || 'pl';
    return next.handle(
      request.clone({setHeaders: {'Content-Language': language}})
    );
  }
}
